import classNames from "clsx";
import React, { ComponentProps } from "react";

import { ResizedImage, Text } from "@shared/elements";

type Props = ComponentProps<typeof ResizedImage> & {
  src: string;
  caption: string;
  description: string;
  containerClasses?: string;
};

export default function ImageBlock({
  src,
  caption,
  description,
  containerClasses,
  rt = "fill",
  ...rest
}: Props) {
  return (
    <div
      className={classNames(
        "flex flex-col items-center lg:items-start",
        containerClasses,
      )}
    >
      <div
        className={`w-full flex flex-col items-center overflow-hidden px-4 lg:px-0`}
      >
        <ResizedImage
          src={`${process.env.NEXT_PUBLIC_CDN_URL}${src}`}
          rt={rt}
          alt={caption}
          {...rest}
        />
      </div>
      <div className="w-full flex flex-col items-start px-4 lg:px-0">
        <Text size="xs" className="mt-2">
          {caption}
        </Text>
        <Text size="xs" color="muted" className="mt-1">
          {description}
        </Text>
      </div>
    </div>
  );
}
